import {ReactElement} from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import {Button} from '@mui/material';
import {useTranslation} from 'react-i18next';

type Props = {
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
};

export default function TelephoneHelpButton({size, color = 'inherit'}: Props): ReactElement {
  const {t} = useTranslation(['shared/common']);
  return (
    <Button
      component="a"
      variant="outlined"
      color={color}
      startIcon={<PhoneIcon />}
      fullWidth
      href={`tel:${t('shared/common:contact.help.telephone')}`}
      size={size}
    >
      {t('shared/common:telephone')}
    </Button>
  );
}
